import { Teacher } from './teacher.model';
import { File } from './file';
import { Translator } from './translator';
export class Knowledge extends Translator{
    id:string
    titleEn:string
    titleKh:string
    teacher:Teacher
    label:string
    descriptionEn:string
    descriptionKh:string
    image:File
    updatedAt:any
    get title():string{
        return this.translate(this.titleEn,this.titleKh)
    }
    get description():string{
        return this.translate(this.descriptionEn,this.descriptionKh)
    }
    mapping = () => {
        let teacher = new Teacher()
        Object.assign(teacher,this.teacher)
        this.teacher = teacher
    }
}